import "./ComputedField.scss";

interface ComputedFieldProps {
  label: string;
  value: string;
  inline?: boolean;
}

const ComputedField = ({ label, value, inline }: ComputedFieldProps) => {
  return (
    <div className={`computed-field${inline ? " computed-field--inline" : ""}`}>
      <label className="computed-field__label">{label}</label>
      <div className="computed-field__value">{value}</div>
    </div>
  );
};

export default ComputedField;
